import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    avatar: null,
};

const avatarSlice = createSlice({
    name: 'avatar',
    initialState,
    reducers: {
        setAvatar: (state, action) => {
            state.avatar = action.payload;
        },
        clearAvatar: (state) => {
            state.avatar = null;
        },
    },
});

export const { setAvatar, clearAvatar } = avatarSlice.actions;



export const { reducer: avatarReducer } = avatarSlice;